import React from 'react'
import { Divider, Text } from 'pcln-design-system'
import AdBanner from '../../AdBanner'
import { AdBox, AdContent } from '../../AdContent'
import AppDownload from '../../AppDownload'
import SEOLinks from '../../SEOLinks'
import BannerContent from '../../BannerContent'
import DISNEY_CONTENT from '../../../constants/promotions/disney'
import UNIVERSAL_CONTENT from '../../../constants/promotions/universal'
import EmailSignUp from '../../EmailSignUp'
import HotelsDealModule from '../HotelsDealModule'
import { ANALYTICS_CATEGORY_HOTELS } from '../../../constants/analytics'
import SEOPRODUCTLINKS from '../../../constants/seo-product-links'
import ExpressDealPromo from '../ExpressDeal/ExpressDealPromo'

const {
  GLOBAL,
  USA,
  EUROPE,
  ASIA,
  INTERNATIONAL
} = SEOPRODUCTLINKS.HOTELS.links.exploreDeals

const HotelsContent = () => {
  return (
    <>
      <Divider borderColor="border.base" my={0} />
      <EmailSignUp category={ANALYTICS_CATEGORY_HOTELS}>
        <Text fontWeight="bold" fontSize={15} py={2}>
          Sign up for email-only coupons, special offers and promotions —
          exclusively from Priceline.
        </Text>
      </EmailSignUp>
      <AdContent>
        <AdBox type="primary">
          <div id="div-gpt-ad-1509978848821-0" />
        </AdBox>
        <AdBox type="secondary">
          <div id="div-gpt-ad-1509978930813-0" />
        </AdBox>
        <AdBox type="tertiary">
          <div id="div-gpt-ad-1509129580404-0" />
        </AdBox>
      </AdContent>
      <Divider borderColor="border.base" my={0} />
      <HotelsDealModule />
      <Divider borderColor="border.base" my={0} />
      <ExpressDealPromo />
      <Divider borderColor="border.base" my={0} />
      <BannerContent banners={[DISNEY_CONTENT, UNIVERSAL_CONTENT]} />
      <AppDownload category={ANALYTICS_CATEGORY_HOTELS} />
      <Divider borderColor="border.base" my={0} />
      {[USA, EUROPE, ASIA, INTERNATIONAL, GLOBAL].map(location => (
        <SEOLinks
          key={location.action}
          caption={location.caption}
          category={ANALYTICS_CATEGORY_HOTELS}
          gaAction={location.action}
          links={location.items}
        />
      ))}
      <Divider borderColor="border.base" my={0} />
      <AdBanner>
        <div id="div-gpt-ad-1509129866793-0" />
      </AdBanner>
      <Divider borderColor="border.base" my={0} />
    </>
  )
}

export default HotelsContent
